import { NavLink } from "react-router-dom";
import "./SettingsSidebar.css";

const NAV_SECTIONS = [
    {
        label: "Company Preferences",
        items: [
            { to: "/settings/company/profile", label: "Company Profile", permKey: "canSeeCompanyProfile" },
            { to: "/settings/company/payments", label: "Payments", permKey: "canSeePayments" },
            { to: "/settings/company/pricing", label: "Pricing", permKey: "canSeePricing" },
            { to: "/settings/company/employees", label: "Employees", permKey: "canSeeEmployees" },
            { to: "/settings/company/locations", label: "Locations", permKey: "canSeeLocations" },
            { to: "/settings/company/supply-chain", label: "Supply Chain", permKey: "canSeeSupplyChain" },
        ],
    }, 
    {
        label: "Account",
        items: [
            { to: "/settings/account/profile", label: "Your Profile", permKey: "canSeeAccountProfile" },
            { to: "/settings/account/preferences", label: "Preferences", permKey: "canSeePreferences" },
        ],
    }, 
    {
        label: "Support",
        items: [
            { to: "/settings/help/faq", label: "FAQ", permKey: "canSeeFaq" },
            { to: "/settings/help/tutorials", label: "Tutorials", permKey: "canSeeTutorials" },
        ],
    },
];

export default function SettingsSidebar({ perms, isMobile, isOpen, onClose, onLogout }) {
    const visibleSections = NAV_SECTIONS.map((section) => ({
        ...section,
        items: section.items.filter((item) => perms[item.permKey]),
    })).filter((section) => section.items.length > 0);

    const handleNavClick = () => {
        if (isMobile) onClose();
    };

    return (
        <>
            {isMobile && isOpen && (
                <div className="settings-sidebar-backdrop" onClick={onClose} />
            )}
            <nav
                className={`settings-sidebar ${isMobile ? "settings-sidebar--mobile" : ""} ${isOpen ? "settings-sidebar--open" : ""}`}
                data-tutorial="settings-tabs"
            >
                {visibleSections.map((section) => (
                    <div key={section.label} className="settings-sidebar__group">
                        <span className="settings-sidebar__group-label">{section.label}</span>
                        {section.items.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end
                                className={({ isActive }) =>
                                    `settings-sidebar__link ${isActive ? "settings-sidebar__link--active" : ""}`
                                }
                                onClick={handleNavClick}
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </div>
                ))}

                <div className="settings-sidebar__footer">
                    <button
                        className="settings-sidebar__logout"
                        onClick={onLogout}
                    >
                        Log Out
                    </button>
                </div>
            </nav>
        </>
    );
}
